module.exports = __webpack_public_path__ + "img/nr 20.e07f2293.jpg";